<!--
    描述：服务费托管
    日期：2022/9/26
    创建人：李家宝
-->
<template>
  <div>
    <el-empty description="暂无数据" v-if="tableData.length == 0"></el-empty>
    <template v-else>
      <div>雇主方-项目服务费托管</div>
      <div class="mt10">
        <el-table
          :data="tableData"
          highlight-current-row
          row-key="id"
          border
          ref="table"
          style="width: 100%"
        >
          <el-table-column
            label="托管日期"
            prop="createDate"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            label="项目服务费金额"
            align="center"
            show-overflow-tooltip
            min-width="100"
          >
            <template slot-scope="scope">
              <span style="color: #0000FF">{{ scope.row.payAmount }}元</span>
            </template>
          </el-table-column>
          <el-table-column
            label="托管方"
            prop="payer"
            show-overflow-tooltip
            align="center"
            min-width="121"
          >
          </el-table-column>
          <el-table-column
            label="付款方证件类型"
            prop="cardType"
            show-overflow-tooltip
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.cardType == 0 ? "身份证" : "营业执照" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="cardNo"
            label="付款方证件号码"
            align="center"
            min-width="111"
          ></el-table-column>
          <el-table-column
            label="收款方"
            prop="payee"
            show-overflow-tooltip
            align="center"
            min-width="121"
          >
          </el-table-column>
          <el-table-column
            label="收款方证件类型"
            prop="payeeCardType"
            show-overflow-tooltip
            align="center"
            min-width="111"
          >
            <template slot-scope="scope">
              {{ scope.row.payeeCardType == 0 ? "身份证" : "营业执照" }}
            </template>
          </el-table-column>
          <el-table-column
            label="收款方证件号码"
            prop="payeeCardNo"
            show-overflow-tooltip
            align="center"
            min-width="111"
          >
          </el-table-column>
          <el-table-column
            label="状态"
            prop="status"
            show-overflow-tooltip
            align="center"
            width="111"
          >
            <template slot-scope="scope">
              {{ scope.row.status == 1 ? "托管中" : "已支付" }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="w-table-footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageList"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import { trusteeFeeGetProjectInfo } from "api/modules/projectManagement";
export default {
  name: "fee-hosting",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: [],
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      auditShow: false, // 审核弹窗的显隐
      btnLoading: false,
      currentRowData: {} // 当前行数据
    };
  },
  methods: {
    // 获取列表数据
    getTrusteeFeeGetProjectInfo() {
      trusteeFeeGetProjectInfo({
        id: this.rowData.businessId,
        current: this.currentPage,
        size: this.pageSize
      }).then(res => {
        if (res.operationCode == 1) {
          this.tableData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
        }
      });
    },
    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTrusteeFeeGetProjectInfo();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTrusteeFeeGetProjectInfo();
    }
  },

  created() {},

  mounted() {}
};
</script>

<style scoped>
.w-table-footer {
  display: flex;
  justify-content: center;
  margin: 20px;
}
</style>
